import React from 'react';

const RELOAD_KEY = 'chunk-reload-attempted';

export const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /not a valid JavaScript MIME type/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
];

export function isChunkLoadError(error) {
  const message = String(error?.message || error || '');

  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message));
}

function tryReloadOnce() {
  if (sessionStorage.getItem(RELOAD_KEY)) return false;
  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.reload();

  return true;
}

export function installChunkErrorRecovery() {
  window.addEventListener(
    'error',
    (event) => {
      const { target } = event;
      if (target && target !== window && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
        const url = target.src || target.href || '';
        if (/\.(m?js)(\?|$)/i.test(url)) {
          tryReloadOnce();
        }

        return;
      }

      if (isChunkLoadError(event.error || event.message)) {
        tryReloadOnce();
      }
    },
    true,
  );

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      tryReloadOnce();
    }
  });
}

export default function lazyWithRetry(factory) {
  return React.lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);

      return mod;
    } catch (error) {
      if (isChunkLoadError(error) && tryReloadOnce()) {
        return { default: () => null };
      }

      throw error;
    }
  });
}
